import { bucketFor } from '../hasura/fileStorage'

/**
 * Upload a file picked in a react-admin FileInput to nhost/storage.
 *
 * `relation` is what the attachment hangs off (`'boats'`, `'customers'`, …):
 * a boat's images go to the public boat-photos bucket, everything else stays
 * private. Resolves to `{ key, ContentType }` — `key` is the file id that
 * attachments.uri stores.
 */
export const uploadBlob = async (blob, formFile, storage, relation) => {
  const file = formFile.rawFile

  // The stored name: the blob-URL id react-admin generated, plus the original
  // extension. (Was path.extname(); a filename extension does not need Node.)
  const fileName = formFile.src.split('/').pop()
  const dot = file.name.lastIndexOf('.')
  const fileExtension = dot > 0 ? file.name.slice(dot) : ''
  const named = new File([blob ?? file], fileName + fileExtension, { type: file.type })

  return storage.put(named, bucketFor(relation, file.type))
}

export default uploadBlob
